module.exports = __webpack_public_path__ + "img/party_upper_6.b123c50b.jpg";